import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { Offer, OfferItem, Product, ProductCountModel, ProductPicture, ResponseWrapper, Contract, Issue, OfferCreatedResponse } from "../../classes";
import { BackEndService } from 'src/app/backend-service';
import { ActivatedRoute, Router } from '@angular/router';
import { PopUpData, PopUpComponent } from '../pop-up/pop-up.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-shop',
  templateUrl: './shop.component.html',
  styleUrls: ['./shop.component.css']
})
export class ShopComponent implements OnInit {

  @Input() set currentOfferInput(offer: Offer) {
    this.currentOffer = offer;
    if (this.currentOffer) this.loadOfferItems();
  }
  @Input() remoteData;

  @Output() offerCreatedEmitter = new EventEmitter<any>();

  currentOffer: Offer;
  requirements: string[] = ["read_issue_items", "create_issue_items", "update_issue_items", "delete_issue_items", "read_products"];

  recentProducts: number[] = [];
  mostCommonProducts: number[] = [];

  issues: Issue[] = [];
  issuesLoading: boolean = false;

  showIssueChooser: boolean = false;

  _productFilter: string = "";
  set productFilter(value: string) {
    if (value == null || typeof (value) == "undefined") this._productFilter = "";
    else this._productFilter = value.toLowerCase();
  }
  get productFilter(): string {
    return this._productFilter;
  }

  get currentIssue(): Issue {
    let offer = this.currentOffer;
    if (offer) return this.issues.find(x => x.issueid == offer.offerissue);
    return null;
  }

  _issueFilter: string = "";
  set issueFilter(value: string) {
    if (value == null || typeof (value) == "undefined") this._issueFilter = "";
    else this._issueFilter = value.toLowerCase();
  }
  get issueFilter(): string {
    return this._issueFilter;
  }

  contracts: Contract[] = [];

  get recentProductObjects(): Product[] {
    let o = [];
    for (let projectId of this.recentProducts) o.push(this.getProductById(projectId));
    return o;
  }

  get mostCommonProductObjects(): Product[] {
    let o = [];
    for (let projectId of this.mostCommonProducts) o.push(this.getProductById(projectId));
    return o;
  }

  products: Product[] = [];

  public shoppingCartItems: OfferItem[] = [];

  productPictureMap = {};

  constructor(
    private _backEndService: BackEndService,
    private route: ActivatedRoute,
    private router: Router,
    private _popUp: MatSnackBar
  ) {
    this.route
      .queryParams
      .subscribe(params => {
        let offerId = parseInt(params["offer"]);
        if (typeof (offerId) == "number" && !isNaN(offerId)) {
          this._backEndService.get(Offer.url + "/" + offerId).subscribe((data: Offer) => {
            this.currentOffer = data;
            this.loadOfferItems();
          });
        }
      });
  }

  accessGranted() {
    return this._backEndService.isAllowedAND(this.requirements);
  }

  addProductToShoppingCart(product: Product) {
    let item = new OfferItem();
    item.isNew = true;
    if (this.currentOffer != null) item.itemoffer = this.currentOffer.offerid;
    item.itemproduct = product.productid;
    item.itemProduct = product;
    item.itemdesc = product.productservice;
    item.iteminfo = product.productdesc;
    item.itempurchasecost = product.productpurchasecost;
    item.itemrentalcost = product.productrentalcost;
    item.itemsetupcost = product.productsetupcost;
    this.shoppingCartItems.push(item);
    item.itemposition = this.shoppingCartItems.length;
    this.productFilter = "";
    this.validatePreviewPicture(product);
  }

  applyIssueFilter(issue: Issue) {
    if (issue.issuenumber != null && issue.issuenumber.toString().indexOf(this._issueFilter) > -1) return true;
    if (issue.issuedesc != null && issue.issuedesc.toLowerCase().indexOf(this._issueFilter) > -1) return true;
    if (issue.issuetitle != null && issue.issuetitle.toLowerCase().indexOf(this._issueFilter) > -1) return true;
    return false;
  }

  applyProductFilter(product: Product) {
    if (product.productnumber != null && product.productnumber.indexOf(this._productFilter) > -1) return true;
    if (product.productservice != null && product.productservice.toLowerCase().indexOf(this._productFilter) > -1) return true;
    return false;
  }

  bookItem(item: OfferItem) {
    if (item.isNew) {
      this._backEndService.post(OfferItem.url, { "content": item }).subscribe((data: ResponseWrapper<OfferItem>) => {
        item.isChanged = false;
        item.isNew = false;
        item.itemid = data.content.itemid;
      });
    } else {
      this._backEndService.put(OfferItem.url, { "content": item }).subscribe((data: ResponseWrapper<OfferItem>) => {
        item.isChanged = false;
        item.isNew = false;
        item.itemid = data.content.itemid;
      });
    }
  }

  bookItems() {
    for (let item of this.shoppingCartItems) this.bookItem(item);
  }

  canBookItems(): boolean {
    if (this.currentOffer && this.countChanges() > 0) return true;
    return false;
  }

  canSaveItem(item: OfferItem) {
    return item.itemoffer != null && (item.isChanged || item.isNew);
  }

  contractMatchesIssueCustomer(contract: Contract): boolean {
    let i = this.currentIssue;
    if (
      contract != null &&
      typeof (contract) != "undefined" &&
      i != null &&
      typeof (i) != "undefined" &&
      contract.contractcustomer != null &&
      i.issuecustomer != null
    ) {
      if (i.issuecustomer == contract.contractcustomer) return true;
      else return false;
    } else {
      return true;
    }
  }

  countChanges(): number {
    var count = 0;
    for (let i of this.shoppingCartItems) if (this.canSaveItem(i)) count++;
    return count;
  }

  downloadPDF() {
    this._backEndService.getBlob(Offer.url + "/downloadoffer/" + this.currentOffer.offerissue).subscribe((response: any) => {
      let file = new Blob([response], { type: 'application/pdf' });
      var fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      let offerCreatedResponse = new OfferCreatedResponse();
      offerCreatedResponse.file = file;
      offerCreatedResponse.items = this.shoppingCartItems;
      offerCreatedResponse.offer = this.currentOffer;
      this.offerCreatedEmitter.emit(offerCreatedResponse);
    });
  }

  duplicateOfferItem(i: OfferItem) {
    let item = new OfferItem();
    item.isNew = true;
    item.isChanged = true;
    if (i.itemoffer != null) item.itemoffer = i.itemoffer;
    item.itemproduct = i.itemproduct;
    item.itemProduct = i.itemProduct;
    item.itemdesc = i.itemdesc;
    item.iteminfo = i.iteminfo;
    item.itempurchasecost = i.itempurchasecost;
    item.itemrentalcost = i.itemrentalcost;
    item.itemsetupcost = i.itemsetupcost;
    item.itembuildindate = i.itembuildindate;
    item.itemcontract = i.itemcontract;
    item.itemlocation = i.itemlocation;
    item.itemposition = i.itemposition;
    item.itemterm = i.itemterm;
    let currentIndex = this.shoppingCartItems.indexOf(i);
    let newCart = [];
    for (let index in this.shoppingCartItems) {
      newCart.push(this.shoppingCartItems[index]);
      if (parseInt(index) == currentIndex) newCart.push(item);
    }
    this.shoppingCartItems = newCart;
  }

  getPictureDataForProduct(product: Product) {
    return this.getPictureData(this.productPictureMap[product.productid].data);
  }
  /**
   * the method generates the img src data for an image
   */
  getPictureData(picture: ProductPicture) {
    return "data:" + picture.picturemediatype + ";base64," + picture.picturedata;
  }

  getPlaceholderImage() {
    return "./assets/unknown.svg";
  }

  getProductById(id: number): Product {
    return this.products.find(x => x.productid == id);
  }

  hasPreviewPicture(product: Product) {
    if (
      typeof (this.productPictureMap[product.productid]) != "undefined" &&
      !this.productPictureMap[product.productid].isLoading
    ) {
      return true;
    }
    return false;
  }

  loadOfferItems() {
    this._backEndService.get(Offer.url + "/" + this.currentOffer.offerid + "/offeritems").subscribe((data: OfferItem[]) => {
      for (let item of data) item.isNew = false;
      for (let item of this.shoppingCartItems) {
        if (item.itemoffer == null) {
          item.itemoffer = this.currentOffer.offerid;
          data.push(item);
        }
      }
      this.shoppingCartItems = data;
    });
  }

  ngOnInit() {
    this._backEndService.get(Product.url).subscribe((products: Product[]) => {
      this.products = products;
    });
    this._backEndService.get(OfferItem.url + "/products/recent/4").subscribe((data: Product[]) => {
      this.recentProducts = data.map(x => x.productid);
      for (let p of data) {
        if (typeof (this.products.find(x => x.productid == p.productid)) == "undefined") this.products.push(p);
        this.validatePreviewPicture(p);
      }
    });
    this._backEndService.get(OfferItem.url + "/products/mostcommon/4").subscribe((data: ProductCountModel[]) => {
      this.mostCommonProducts = data.map(x => x.product.productid);
      for (let p of data.map(x => x.product)) {
        if (typeof (this.products.find(x => x.productid == p.productid)) == "undefined") this.products.push(p);
        this.validatePreviewPicture(p);
      }
    });
    this._backEndService.get(Contract.url).subscribe((data: Contract[]) => {
      this.contracts = data;
    });
  }

  removeOfferItem(item: OfferItem) {
    if (item.isNew) this.removeIssueLocalItemFromShoppingCart(item);
    else {
      this._backEndService.delete(OfferItem.url + "/" + item.itemid).subscribe(() => {
        this.removeIssueLocalItemFromShoppingCart(item);
      });
    }
  }

  removeIssueLocalItemFromShoppingCart(item: OfferItem) {
    let i = this.shoppingCartItems.indexOf(item);
    if (i > -1) this.shoppingCartItems.splice(i, 1);
  }

  selectIssue() {
    if (this.issues.length == 0 && !this.issuesLoading) {
      this.issuesLoading = true;
      this._backEndService.get(Issue.url).subscribe((issues: Issue[]) => {
        this.issues = issues;
        this.issuesLoading = false;
      });
    }
    this.showIssueChooser = true;
  }
  /**
   * the method set's the pop up data
   */
  setPopUp(data: PopUpData) {
    this._popUp.openFromComponent(PopUpComponent, {
      duration: 2000,
      data: data
    });
  }

  setValue(object: any, attr: string, value: any) {
    object[attr] = value;
    object.isChanged = true;
  }

  setValueNumber(object: any, attr: string, value: any) {
    var val = parseFloat(value);
    if (isNaN(val)) object[attr] = 0;
    else {
      object[attr] = val;
    }
    object.isChanged = true;
  }

  get sumSingular(): number {
    var output = 0;
    let set = this.shoppingCartItems.map(x => (x.itemsetupcost * x.itemcount));
    for (let c of set) output += c;
    let pur = this.shoppingCartItems.map(x => (x.itempurchasecost * x.itemcount));
    for (let c of pur) {
      output += c;
    }
    return output;
  }

  get sumMonthly(): number {
    var output = 0;
    let mon = this.shoppingCartItems.map(x => (x.itemrentalcost * x.itemcount));
    for (let c of mon) output += c;
    return output;
  }

  validatePreviewPicture(product: Product) {
    if (typeof (this.productPictureMap[product.productid]) == "undefined" || !this.productPictureMap[product.productid].isLoading) {
      this.productPictureMap[product.productid] = {
        isLoading: true,
        data: null
      };
      this._backEndService.get(Product.url + "/" + product.productid + "/previewpicture").subscribe((picture: ProductPicture) => {
        this.productPictureMap[picture.productid].isLoading = false;
        this.productPictureMap[picture.productid].data = picture;
      });
    }
  }

}
